export const containerWidthMap = {
    small: 'var(--container-width--small)',
    medium: 'var(--container-width--medium)',
    large: 'var(--container-width--large)',
};
